import React from 'react';
import { toast } from 'react-toastify';
import { useSelector } from 'react-redux';

import {
  isArray,
  isEmpty,
  find,
  concat,
  assign,
  isNumber,
  findIndex,
  includes,
  isNull,
} from 'lodash';
import PropTypes from 'prop-types';
import qs from 'querystring';
import * as Yup from 'yup';

import { TextField, Button, Typography } from '@material-ui/core';

import { Form as FormUI, DateTime, Input } from '~/components/Form';
import { t, number } from '~/helpers';
import api from '~/services/api';
import { Modal, ConfirmationDialogRaw } from '~/components';
import { ONLINE } from '~/constants/default';

import * as S from './styles';

import { Bicos, Tabela, Tanques, Loading } from '..';

export default function FormGPP({
  posto,
  tabelas,
  type,
  sending,
  visible,
  close,
}) {
  const formRef = React.useRef(null);
  const bicoRef = React.useRef(null);
  const tanqueRef = React.useRef(null);
  const loadingRef = React.useRef(null);

  const { id } = useSelector((state) => state.user.profile);

  const [tanques, setTanques] = React.useState(tabelas.tanques || []);
  const [bicos, setBicos] = React.useState(tabelas.bicos || []);

  const [justificativa, setJustificativa] = React.useState('');

  /*
data.bicos.map((bico) => ({
          ...bico,
          mecanicoinicioturnobico: number(bico.mecanicoinicioturnobico, 1),
          eletronicofimturnobico: number(bico.eletronicofimturnobico, 1),
          diferenca: number(bico.diferenca, 1),
        }))
  */



  const [dadosTanqueTurnoConfirmacao, setDadosTanqueTurnoConfirmacao] =
    React.useState(
      (tabelas.dadosTurnoConfirmacaoGPP.dadosTanqueTurnoConfirmacao) ?
        tabelas.dadosTurnoConfirmacaoGPP.dadosTanqueTurnoConfirmacao.map((dadosTanqueTurnoConfirmacao) => ({
          ...dadosTanqueTurnoConfirmacao,
          difVolume: number(dadosTanqueTurnoConfirmacao.difVolume, 2),
          difPercentual: number(dadosTanqueTurnoConfirmacao.difPercentual, 2),
          volContabil: number(dadosTanqueTurnoConfirmacao.volContabil, 2),
          volMedido: number(dadosTanqueTurnoConfirmacao.volMedido, 2),

        }))
        : []
    );
  const [dadosBicoTurnoConfirmacao, setDadosBicoTurnoConfirmacao] =
    React.useState(
      (tabelas.dadosTurnoConfirmacaoGPP.dadosBicoTurnoConfirmacao) ?
        tabelas.dadosTurnoConfirmacaoGPP.dadosBicoTurnoConfirmacao.map((dadosBicoTurnoConfirmacao) => ({
          ...dadosBicoTurnoConfirmacao,
          difVolume: number(dadosBicoTurnoConfirmacao.difVolume, 1),
          difPercentual: number(dadosBicoTurnoConfirmacao.difPercentual, 1),
          encerranteEletronico: number(dadosBicoTurnoConfirmacao.encerranteEletronico, 1),
          encerranteMecanico: number(dadosBicoTurnoConfirmacao.encerranteMecanico, 1),
        }))
        : []
    );
  const [dadosTurnoConfirmacaoGPP, setDadosTurnoConfirmacaoGPP] = React.useState(tabelas.dadosTurnoConfirmacaoGPP || []);



  // Title
  const titleModal = React.useMemo(() => {
    if (type === 2) return t('s.operacao.turno.abrirturno');
    if (type === 3) return t('s.operacao.turno.transferir');
    if (type === 4) return "Abertura do turno";
    if (type === 5) return "Fechamento do turno";

    return t('s.operacao.turno.fecharturno');
  }, [type]);

  // Message success
  const messageSuccess = React.useMemo(() => {
    if (type === 2) return t('s.operacao.turno.turnoabertosucesso');
    if (type === 3) return t('s.operacao.turno.turnotransferido');
    if (type === 4) return "Processo executado!";
    if (type === 5) return "Processo executado!";

    return 'Processo executado!';
  }, [type]);


  // Text view
  const textView = React.useMemo(() => {
    if (includes([1, 3], type)) return 'TURNO ABERTO';
    if (type === 2) return 'TURNO FECHADO';
    if (type === 4) return 'Turno ABERTO aguardando confirmação do gestor';
    if (type === 5) return 'Turno FECHADO aguardando confirmação do gestor';
    return '';
  }, [type]);


  // Validate form
  const schemaConfimar = React.useMemo(
    () =>
      Yup.object().shape({
        justificativa: Yup.string()
        .required(t('s.geral.validacao.campoobrigatorio'))
        .max(500, t('s.geral.validacao.tamanhomaximo').replace('%s', 500)),               
      }),
    [type]
  );


  const schema = React.useMemo(
    () =>
      Yup.object().shape({        
      }),
    [type]
  );

  // Callback edit encerrante mecanico
  const handleCallbackMecanico = React.useCallback(
    (value, index, item) => {
      const modifyBicos = concat([], bicos);

      if (item) modifyBicos[index][item] = value;
      else {
        modifyBicos[index].encerrantedigitadobico = value;
        modifyBicos[index].confirmadivergenciaencerrantebicooper = false;
        modifyBicos[index].confirmaerroatualizacaoencerrantebicooper = false;
      }

      setBicos(modifyBicos);
    },
    [bicos]
  );

  // Tabela de tanques
  const cellTanques = React.useMemo(
    () => [
      { id: 'tafiCodigo', label: 'Tanque' },
      {
        id: 'volContabil',
        label: 'Volume Contábil',
        align: 'right',
        //format: (value) => number(value, 1),
      },
      {
        id: 'volMedido',
        label: 'Volume Medido',
        align: 'right',
        //format: (value) => number(value, 1),
      },
      {
        id: 'difVolume',
        label: 'Diferença Volume',
        align: 'right',
        //format: (value) => number(value, 1),
      },
      {
        id: 'difPercentual',
        label: 'Diferença Percentual',
        align: 'right',
        //format: (value) => number(value, 1),
      },
    ],
    [tanques]
  );

  // Tabela de bicos
  const cellBicos = React.useMemo(
    () => [
      { id: 'bicoNumero', label: 'Bico' },
      {
        id: 'encerranteEletronico',
        label: 'Encerrante Eletrônico',
        align: 'right',
      //  format: (value) => number(value, 1),
      },
      {
        id: 'encerranteMecanico',
        label: 'Encerrante Mecânico',
        align: 'right',
       // format: (value) => number(value, 1),
      },
      {
        id: 'difVolume',
        label: 'Difença Volume',
        align: 'right',
       // format: (value) => number(value, 1),
      },
      {
        id: 'difPercentual',
        label: 'Difença Percentual',
        align: 'right',
      //  format: (value) => number(value, 1),
      },
    ],
    [bicos]
  );

  // Validate bicos
  const handleValidationBicos = React.useCallback(async () => {
    const errors = [];

    bicos
      .filter((bico) => bico.automaticobico === 'N')
      .map((bico) => {
        const { encerrantedigitadobico } = bico;

        if (!encerrantedigitadobico)
          errors.push(
            t('s.operacao.turno.digiteencerramento').replace('%s', bico.idbico)
          );

        return true;
      });

    if (!isEmpty(errors)) throw errors;
  }, [bicos]);

  // Validade tanques
  const handleValidationTanques = React.useCallback(async () => {
    const errors = [];

    tanques.map((tanque) => {
      const { alturatanquefisico, alturaaguatanquefisico } = tanque;

      if (!isNumber(alturatanquefisico) || !isNumber(alturaaguatanquefisico))
        errors.push(
          t('s.operacao.recebimentonf.digitealtura').replace(
            '%s',
            tanque.codigotanquefisico
          )
        );

      return true;
    });

    if (!isEmpty(errors)) throw errors;
  }, [tanques]);

  // Validade erros response
  const handleValidateErrorsResponse = React.useCallback(
    async (response) => {
      const { retorno, mensagem } = response;

      // Checks for nozzle errors
      if (!isEmpty(response.bicos)) {
        const item = response.bicos.shift();
        const index = findIndex(bicos, (bico) => bico.idbico === item.idbico);

        // Divergencia encerrante
        if (item.divergenciaencerrante)
          bicoRef.current.handleOpenModal({
            bico: bicos[index],
            error: 1,
            position: index,
          });

        // Erro atualização encerrante
        if (item.erroatualizacaoencerrante)
          bicoRef.current.handleOpenModal({
            bico: bicos[index],
            error: 2,
            position: index,
          });

        throw mensagem;
      }

      // Checks for tank errors
      if (!isEmpty(response.tanques)) {
        const item = response.tanques.shift();
        const index = findIndex(
          tanques,
          (tanque) => tanque.idtanquefisico === item.idtanquefisico
        );

        // Divergência volume
        if (item.divergenciavolume)
          tanqueRef.current.handleOpenModal({
            tanque: tanques[index],
            error: 1,
            position: index,
          });

        // Divergência volume anterior
        if (item.divergenciavolumeturnoAnterior)
          tanqueRef.current.handleOpenModal({
            tanque: tanques[index],
            error: 2,
            position: index,
          });

        throw mensagem;
      }

      if (!retorno && mensagem) throw mensagem;
    },
    [bicos, tanques]
  );

  // Submit handleSubmitConfirmar






  const handleSubmitConfirmar = React.useCallback(
    async (data) => {
      try {
        loadingRef.current.handleOpenModal();

        await schemaConfimar.validate({justificativa}, {
          abortEarly: false,
        });




        let statusOper = "";
        if (type === 4) {
          statusOper = 'ABERTURA';
        }
        if (type === 5) {
          statusOper = 'FECHAMENTO';
        }


        const objectSend = {
          idturno: tabelas.idturno,
          idposto: posto.poco_codigo,
          observacaoturno: justificativa,
          statusOper: statusOper,
          dadosBicoTurnoConfirmacao: tabelas.dadosTurnoConfirmacaoGPP.dadosBicoTurnoConfirmacao,
        };

        const response = await api.put('turnos/persisteConfirmaGPP', objectSend);        

        await handleValidateErrorsResponse(response.data);
        await close();

        toast.success(messageSuccess);
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          if (isNull(formRef)) {
            formRef.current.setErrors(validationErrors);
          }

        } else if (isArray(err)) {
           err.map((e) => toast.error(t(e)));
        } else if (!isEmpty(err)) {
          toast.error(t(err));
        } else {
          toast.error("Erro durante o retorno da resposta do servidor TcoUdtMG!");
        }   

      } finally {
        if (!isNull(loadingRef)) {
          loadingRef.current.handleCloseModal();
        }
      }
    },
    [type, bicos, tanques, tabelas, posto, messageSuccess, justificativa]
  );


  const handleSubmitCancelar = React.useCallback(
    async (data) => {
      try {
        loadingRef.current.handleOpenModal();

        await schema.validate(data, {
          abortEarly: false,
        });


        let statusOper = "";
        if (type === 4) {
          statusOper = 'ABERTURA';
        }
        if (type === 5) {
          statusOper = 'FECHAMENTO';
        }


        const objectSend = {
          idturno: tabelas.idturno,
          idposto: posto.poco_codigo,
          observacaoturno: "",
          statusOper: statusOper,
        };

        const response = await api.put('turnos/persisteCancelarGPP', objectSend);

        await handleValidateErrorsResponse(response.data);
        await close();

        toast.success(messageSuccess);
      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          formRef.current.setErrors(validationErrors);
        } else if (isArray(err)) err.map((e) => toast.error(t(e)));
        else if (!isEmpty(err)) toast.error(t(err));
      } finally {
        loadingRef.current.handleCloseModal();
      }
    },
    [type, bicos, tanques, tabelas, posto, messageSuccess]
  );








  // Request API Tanques
  // const handleGetRequestTanques = React.useCallback(async () => {
  //   const params = {
  //     wherefield: ['idposto', 'statustanquefisico', 'tipoproduto'],
  //     valuewherefield: [posto.idposto, 'L', 'G'],
  //     typewherefield: ['EQUALS', 'EQUALS', 'NEQUALS'],
  //   };

  //   try {
  //     const { data } = await api.get('estoquestanquespostoscomboios', {
  //       params,
  //       paramsSerializer: (param) => qs.stringify(param),
  //     });

  //     // Verifica se não existem tanques
  //     if (isEmpty(tanques)) {
  //       setTanques(
  //         data.items.map((item) => ({
  //           idtanquefisico: item.idtanquefisico,
  //           codigotanquefisico: item.codigotanquefisico,
  //           alturatanquefisico: item.alturanivel1tanquefisico,
  //           volumetanquefisico: item.volume1tanquefisico,
  //           alturaaguatanquefisico: item.alturanivel2tanquefisico,
  //           volumeaguatanquefisico: item.volume2tanquefisico,
  //           volumecontabil: item.volume1tanquefisico,
  //           confirmadivergenciavolume: false,
  //           status: item.statustanquefisico,

  //           statussondatanquefisico: item.statussondatanquefisico,
  //           idarqueacao: item.idarqueacao,
  //           idposto: item.idposto,
  //         }))
  //       );
  //     } else {
  //       const modifyTanques = tanques.map((tanque) => {
  //         const findTanque = find(
  //           data.items,
  //           (item) => item.idtanquefisico === tanque.idtanquefisico
  //         );

  //         if (findTanque && findTanque.statussondatanquefisico === ONLINE) {
  //           return {
  //             ...tanque,
  //             codigotanquefisico: findTanque.codigotanquefisico,
  //             alturatanquefisico: findTanque.alturanivel1tanquefisico,
  //             volumetanquefisico: findTanque.volume1tanquefisico,
  //             alturaaguatanquefisico: findTanque.alturanivel2tanquefisico,
  //             volumeaguatanquefisico: findTanque.volume2tanquefisico,
  //             volumecontabil: findTanque.volume1tanquefisico,
  //             confirmadivergenciavolume: false,
  //             status: findTanque.statustanquefisico,
  //             statussondatanquefisico: findTanque.statussondatanquefisico,
  //             idarqueacao: findTanque.idarqueacao,
  //           };
  //         }

  //         return assign(tanque, {
  //           idarqueacao: findTanque.idarqueacao,
  //           statussondatanquefisico: findTanque.statussondatanquefisico,
  //         });
  //       });

  //       setTanques(modifyTanques);
  //     }
  //   } catch (err) {
  //     if (isArray(err)) err.map((e) => toast.error(t(e)));
  //     else toast.error(t(err));
  //   }
  // }, [tanques, posto]);

  // Request API Bicos
  // const handleGetRequestBicos = React.useCallback(async () => {
  //   const params = {
  //     pagesize: 99999,
  //     wherefield: ['idposto', 'statusbico', 'tipoproduto'],
  //     valuewherefield: [posto.idposto, 'L', 'G'],
  //     typewherefield: ['EQUALS', 'EQUALS', 'NEQUALS'],
  //   };

  //   try {
  //     const { data } = await api.get('bicos', {
  //       params,
  //       paramsSerializer: (param) => qs.stringify(param),
  //     });

  //     if (isEmpty(bicos)) setBicos(data.items);
  //     else {
  //       const modifyBicos = bicos.map((bico) => {
  //         const findBico = find(
  //           data.items,
  //           (item) => item.idbico === bico.idbico
  //         );

  //         if (findBico && findBico.automaticobico === 'S') {
  //           return {
  //             ...bico,
  //             encerrantebico: findBico.encerrantebico,
  //             encerrantedigitadobico: findBico.encerrantebico,
  //           };
  //         }

  //         return {
  //           ...bico,
  //           automaticobico: findBico.automaticobico,
  //           encerrantebico: findBico.encerrantebico,
  //         };
  //       });

  //       setBicos(modifyBicos);
  //     }
  //   } catch (err) {
  //     if (isArray(err)) err.map((e) => toast.error(t(e)));
  //     else toast.error(t(err));
  //   }
  // }, [bicos, posto]);

  // onForm change modal bico
  const handleOnFormChangedBico = React.useCallback(
    (params) => {
      const { error, position } = params;

      if (error === 1) {
        handleCallbackMecanico(
          true,
          position,
          'confirmadivergenciaencerrantebicooper'
        );
      }

      if (error === 2)
        handleCallbackMecanico(
          true,
          position,
          'confirmaerroatualizacaoencerrantebicooper'
        );

      if (error === 3)
        handleCallbackMecanico(
          true,
          position,
          'confirmadivergenciaencerrantebicooper'
        );

      formRef.current.submitForm();
    },
    [bicos]
  );

  // onForm change modal tanque
  const handleOnFormChangedTanque = React.useCallback(
    (params) => {
      const { error, position } = params;

      const modifyTanks = concat([], tanques);

      if (error === 1) {
        modifyTanks[position].confirmadivergenciavolume = true;
      }

      if (error === 2) {
        modifyTanks[position].divergenciavolumeturnoAnterior = true;
      }

      setTanques(modifyTanks);
      formRef.current.submitForm();
    },
    [tanques]
  );

  // React.useEffect(() => {
  //   handleGetRequestTanques();
  //   handleGetRequestBicos();
  // }, []);

  // React.useEffect(() => {
  //   const interval = setInterval(() => {
  //     handleGetRequestTanques();
  //   }, 60000);

  //   return () => clearInterval(interval);
  // }, [tanques, bicos]);

  React.useEffect(() => {
    if (sending) formRef.current.submitForm();
  }, [sending]);

  React.useEffect(() => {
    if (!visible) {
      setTanques([]);
      setBicos([]);
    }
  }, [visible]);



  //Confirmar o registro do turno
  const [openConfirmar, setOpenConfirmar] = React.useState(false);
  const [value, setValue] = React.useState("CLICK-OK");
  //const [registro, setRegistro] = React.useState('');
  const execHandleConfirmar = () => {
    //setRegistro(registro);
    setOpenConfirmar(true);
  };
  const handleConfirmarClose = (newValue) => {
    //console.log(newValue);
    setOpenConfirmar(false);
    if (newValue) {
      setValue(newValue);
      if (newValue === 'CLICK-OK') {
        handleSubmitConfirmar();
      }
    }
  };


  //Cancelar o registro do turno
  const [openCancelar, setOpenCancelar] = React.useState(false);
  const [valueCancelar, setValueCancelar] = React.useState("CLICK-OK");
  //const [registro, setRegistro] = React.useState('');
  const execHandleCancelar = () => {
    //setRegistro(registro);
    setOpenCancelar(true);
  };
  const handleCancelarClose = (newValue) => {
    //console.log(newValue);
    setOpenCancelar(false);
    if (newValue) {
      setValue(newValue);
      if (newValue === 'CLICK-OK') {
        handleSubmitCancelar();
      }
    }
  };




  const handleValidaSubmitCancelar = React.useCallback(
    async (data) => {
      try {

        await schema.validate(data, {
          abortEarly: false,
        });

        execHandleCancelar();


      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          formRef.current.setErrors(validationErrors);
        } else if (isArray(err)) err.map((e) => toast.error(t(e)));
        else if (!isEmpty(err)) toast.error(t(err));
      }
    },
    [type, bicos, tanques, tabelas, posto, messageSuccess]
  );


  const handleValidaSubmitConfirmar = React.useCallback(
    async (data) => {
      try {
        await schemaConfimar.validate({justificativa}, {
          abortEarly: false,
        });

        execHandleConfirmar();

      } catch (err) {
        const validationErrors = {};

        if (err instanceof Yup.ValidationError) {
          err.inner.forEach((error) => {
            validationErrors[error.path] = error.message.replace(
              `${error.path} `,
              ''
            );
          });

          formRef.current.setErrors(validationErrors);

        } else if (isArray(err)) err.map((e) => toast.error(t(e)));
        else if (!isEmpty(err)) toast.error(t(err));
      }

    }, [type, bicos, tanques, tabelas, posto, messageSuccess, justificativa]
  );

  
  // Initial data
  const initials = React.useMemo(
    () => ({
      justificativa: '',
      nomeposto: posto.poco_descricao || '',
      datahorainicialturno: type === 4 ? tabelas.datahorainicialturno : null,
      observacaoinicioturno: type === 5 ? tabelas.observacaoinicioturno : null,
      operador: type === 4 ? tabelas.codigousuarioinicialturno : tabelas.codigousuariofinalturno,
    }),
    [posto, tabelas, type]
  );
  
  return (
    <S.Wrapper>

      <div >
        <ConfirmationDialogRaw
          id="ringtone-menu-confirmar"
          keepMounted
          open={openConfirmar}
          onClose={handleConfirmarClose}
          valueProp={value}
          mensagem='Deseja confirmar os dados do turno?'
        />
      </div>


      <div >
        <ConfirmationDialogRaw
          id="ringtone-menu-cancelar"
          keepMounted
          open={openCancelar}
          onClose={handleCancelarClose}
          valueProp={valueCancelar}
          mensagem='Deseja cancelar os dados do turno?'
        />
      </div>

      <FormUI ref={formRef} onSubmit={(e) => e.preventDefault()} initialData={initials}>

        <S.WrapperGroupButton>
          <Button size="small" variant="outlined" onClick={handleValidaSubmitConfirmar} color="primary">
            Confirmar Turno
          </Button>

          <Button size="small" variant="outlined" onClick={handleValidaSubmitCancelar} color="primary">
            Cancelar Turno
          </Button>

        </S.WrapperGroupButton>

        <S.WrapperForm>

          <Typography>{textView}</Typography>

          <S.WrapperGroupInput>

            <Input
              disabled
              name="nomeposto"
              label='Posto'
            />

            <Input
              disabled
              name="operador"
              label='Operador'
            />
          </S.WrapperGroupInput>


          {type === 4 && (
            <S.WrapperGroupInput>
              <DateTime
                time
                nullable
                name="datahorainicialturno"
                label='Abertura'
                disabled
              />
            </S.WrapperGroupInput>
          )}

          {type === 5 && (
            <S.WrapperGroupInput>
              <DateTime
                time
                nullable
                name="datahorafinalturno"
                label="Fechamento"
                disabled
              />
            </S.WrapperGroupInput>
          )}


          <S.WrapperGroupInputBox>
            <Input
              multiline
              value={justificativa}
              rows={3}
              onChange={event => {
                setJustificativa(event.target.value);            
              }}
              name="justificativa"
              label='Justificativa'
            />
          </S.WrapperGroupInputBox>




        </S.WrapperForm>

        <Tabela
          title='DADOS DOS BICOS'
          cells={cellBicos}
          data={dadosBicoTurnoConfirmacao}
          size="small"
        />

        <Tabela
          title='DADOS DOS TANQUES'
          cells={cellTanques}
          data={dadosTanqueTurnoConfirmacao}
          size="small"
        />
      </FormUI>

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={bicoRef}
        title={t('s.operacao.turno.encerrantesbicos')}
        component={Bicos}
        onForm={handleOnFormChangedBico}
      />

      <Modal
        form
        disableBackdropClick
        disableEscapeKeyDown
        ref={tanqueRef}
        title={t('s.operacao.turno.estoquefisico')}
        component={Tanques}
        onForm={handleOnFormChangedTanque}
      />


      <Modal
        maxWidth="xs"
        disableBackdropClick
        disableEscapeKeyDown
        ref={loadingRef}
        title={titleModal}
        component={Loading}
      />
    </S.Wrapper>
  );
}

FormGPP.propTypes = {
  posto: PropTypes.objectOf(
    PropTypes.shape({
      nomeposto: PropTypes.string,
      idposto: PropTypes.number,
      transfereturnoposto: PropTypes.number,
    })
  ),
  tabelas: PropTypes.objectOf(PropTypes.any),
  type: PropTypes.number,
  sending: PropTypes.bool.isRequired,
  visible: PropTypes.bool.isRequired,
  close: PropTypes.func.isRequired,
};

FormGPP.defaultProps = {
  posto: {},
  type: 0,
  tabelas: {},
};
